import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import { Button } from "react-bootstrap";
import helper from "../../lib/helper";
import teamModel from "../../models/team.model";
import useSWR from "swr";
import Pagination from "../../components/Pagination";
import Heading from "../../components/Heading";
import Table from "../../components/Table";
import { useRouter } from "next/router";
import config from "../../lib/config";
import moment from "moment/moment";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);

    const router = useRouter();
    const queryParams = router.query;
    const { data: teamData, mutate: teamPageData, isLoading } = useSWR(
        queryParams || null,
        () => teamModel.list(queryParams),
        config.swrConfig
    );
    console.log('teamDaaaata', teamData?.data)
    const columns = [


        {
            Header: "Full_Name",
            className: "col",
            accessor: "name",

            Cell: ({ row }) => (
                <>
                    <img src={row.original.avatar} className="me-1" height="40px" width="50px" />
                    {row.original.name}
                </>
            )

        },

        {
            Header: 'Email',
            accessor: 'email',
            className: 'col'
        },
        {
            Header: 'Mobile',
            accessor: 'mobile',
            className: 'col'
        },
        {
            Header: "Date",
            id: "created_at",
            Cell: ({ row }) => (
                <>
                    <div>
                    {helper.date.format(row.original.created_at)}
                    </div>
                </>
            )
            },
        {
            className: "col-auto text-end",
            Header: "Actions",
            id: "action",
            Cell: ({ row }) => (
                <>
                    <div className="btn-group btn-group-sm">
                        <Link
                            className="btn btn-primary"
                            href={`/teams/${row.original.id}`}
                        >
                            <i className="bi bi-eye"></i>
                        </Link>
                        <Link
                            className="btn btn-warning"
                            href={`/teams/${row.original.id}/edit`}
                        >
                            <i className="bi bi-pencil-square"></i>
                        </Link>
                        <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(row.original.id, row.original.name)}
                        >
                            <i className="bi bi-trash"></i>
                        </button>
                    </div>
                </>
            ),
        },



    ];
    const confirmDelete = async (id, title) => {
        await helper.sweetalert
            .confirm(`confirm to delete ${title}`, "warning")
            .then(async (result) => {
                if (result.isConfirmed) {
                    setShowLoader(true);
                    await teamModel.destroy(id).then((res) => {
                        teamPageData();
                        helper.sweetalert.toast(`${title} deleted Successfully`);
                    });
                    setShowLoader(false);
                }
            });
    };

    return (
        <>

            {teamData ? (
                console.log('teamData', teamData),
                <Heading title="team">

                    {console.log('ShowLoader', showLoader)}
                    <Button className="btn btn-primary btn-sm" href="/teams/create">
                        Create
                    </Button>
                </Heading>) : (
                <Heading title="team" showLoader={isLoading || showLoader}>
                    {console.log('ShowLoader', showLoader)}
                    <Button className="btn btn-primary btn-sm" href="/teams/create">
                        Create
                    </Button>
                </Heading>
            )}
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">team Lists</div>
                    <div className="table-responsive">
                        <Table columns={columns} data={teamData?.data || []} />

                        {console.log('teamDataaaaaaaaaaaa', teamData?.data)}
                    </div>
                    <div className="card-footer">
                        <Pagination meta={teamData?.meta} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;




